import _ from 'lodash/fp';

export default [
  {
    name: 'Halo',
    gradient: {
      scale: 1,
      speed: 0.01,
      rotation: 90,
      stops: [
        [[0, 0, 0], 0.0],
        [[0, 0, 0], 0.2921914],
        [[1, 1, 1], 0.5],
        [[0.0411, 0.0411, 0.0411], 0.6776819]
      ]
    },
    wave: {
      enabled: false,
      scale: 2,
      speed: 0.002,
      rotation: 90,
      intensity: 200,
      stops: [['black', 0], ['black', 1]]
    },
    sparkle: {
      enabled: false,
      opacity: 0.5,
      speed: 10,
      scale: 1
    }
  },
  {
    name: 'Pacific',
    gradient: {
      scale: 1,
      speed: 0.5,
      rotation: 90,
      stops: [
        [[0.074936, 0.179452, 0.493], 0],
        [[0, 0.7, 1.0], 0.5],
        [[0.074936, 0.179452, 0.493], 1]
      ]
    },
    wave: {
      enabled: false,
      scale: 2,
      speed: 0.002,
      rotation: 90,
      intensity: 200,
      stops: [['black', 0], ['black', 1]]
    },
    sparkle: {
      enabled: true,
      opacity: 0.5,
      speed: 1,
      scale: 1
    }
  },
  {
    name: 'Solar',
    gradient: {
      scale: 3,
      speed: 0.5,
      rotation: 90,
      stops: [
        [[1, 0.316667, 0], 0],
        [[1, 0.84225, 0.369], 0.1259446],
        [[0.486, 0.8629333, 1], 0.2670025],
        [[0.726693, 0.500051, 0.851837], 0.4130982],
        [[0.082431, 0.1281164, 0.387], 0.5945585],
        [[1, 0.316667, 0], 1]
      ]
    },
    wave: {
      enabled: false,
      scale: 2,
      speed: 0.002,
      rotation: 90,
      intensity: 200,
      stops: [['black', 0], ['black', 1]]
    },
    sparkle: {
      enabled: true,
      opacity: 0.5,
      speed: 1,
      scale: 1
    }
  }
];



// WEBPACK FOOTER //
// ./src/components/content.js